import { FilterOption } from '../../../components/_WMS/FilterComponent'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'asnId',
    label: 'ID ASN',
    type: 'numeric'
  },
  {
    order: 2,
    key: 'asnNumber',
    label: 'Nro ASN',
    type: 'text'
  },
  {
    order: 3,
    key: 'WorkOrderId',
    label: 'ID OT',
    type: 'numericnotnegative'
  },
  {
    order: 4,
    key: 'receivedDate',
    label: 'Fecha recepcion Desde',
    type: 'date'
  },
  {
    order: 5,
    key: 'receivedDate',
    label: 'Fecha recepcion Hasta',
    type: 'date'
  },
  {
    order: 6,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  }
  ,
  {
    order: 7,
    key: 'productOriginId',
    label: 'Origen Marca',
    type: 'precreated'
  }

]

export const defaultFilters = [
]
